import { useState } from 'react'
import { useContent } from '../contexts/ContentContext'
import { useNavigation } from '../contexts/NavigationContext'

export default function DesktopNav({ onDark = false }) {
  const { menu } = useContent()
  const { navigateTo } = useNavigation()
  const [openIndex, setOpenIndex] = useState(null)

  const handleNavClick = (anchor) => {
    navigateTo(anchor)
    setOpenIndex(null)
  }

  const linkClass = onDark
    ? 'px-3 py-2 font-primary text-menu-text text-primary-on-dark rounded hover:bg-white/10 transition-colors'
    : 'px-3 py-2 font-primary text-menu-text text-color-primary rounded hover:bg-color-bg-light transition-colors'

  return (
    <nav className="flex items-center justify-center flex-1 gap-6">
      {/* Navigation Menu */}
      <ul className="flex items-center gap-1">
        {menu.header.mainNav.map((item, index) => (
          <li
            key={item.label}
            className="relative"
            onMouseEnter={() => item.hasSubmenu && setOpenIndex(index)}
            onMouseLeave={() => setOpenIndex(null)}
          >
            <button
              className={linkClass}
              onClick={() => !item.hasSubmenu && handleNavClick(item.anchor)}
            >
              {item.label}
            </button>

            {item.hasSubmenu && openIndex === index && (
              <ul className="absolute top-full left-0 min-w-[200px] bg-color-card-overlay backdrop-blur-[16px] rounded-lg shadow-xl py-1 z-50">
                {menu.items
                  .find(cat => cat.label === item.label)
                  ?.children.map((child) => (
                    <li key={child.id}>
                      <button
                        onClick={() => handleNavClick(child.anchor)}
                        className="block w-full text-left px-4 py-2 font-primary text-menu-text text-color-text hover:font-bold transition-all"
                      >
                        {child.label}
                      </button>
                    </li>
                  ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </nav>
  )
}
